import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(78);
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 56,
    s: 9
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
        return {
          h: Math.floor(seconds / 3600),
          m: Math.floor(seconds % 3600 / 60),
          s: seconds % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = window.setInterval(() => setSpotsTaken(current => Math.min(current + 1, 94)), 45000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const time = `${format(timeLeft.h)}:${format(timeLeft.m)}:${format(timeLeft.s)}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/50 bg-brand-purpleDark text-white shadow-md" data-id="element-273" data-mp="27fhx55y8tifo">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-274" data-mp="22mosei2rya3l">
        <div className="hidden items-center justify-center gap-5 text-sm font-medium md:flex" data-id="element-275" data-mp="1xo56gho6kyb8">
          <div className="flex items-center gap-2 text-brand-goldLight" data-id="element-276" data-mp="1sqleyg2h2p1c">
            <ClockIcon className="h-4 w-4" data-id="element-277" data-mp="2qdkdkwcq671v" />
            <span data-id="element-278" data-mp="2qc9db6ihnhfi">PRECIO DE LANZAMIENTO CIERRA EN:</span>
            <span className="rounded bg-white/15 px-2 py-0.5 font-mono font-bold tabular-nums text-white" data-id="element-279" data-mp="2ler0v659ik2r">{time}</span>
          </div>
          <span className="h-4 w-px bg-white/25" data-id="element-280" data-mp="2ged4ild0wykk" />
          <span data-id="element-281" data-mp="2gh92uass9p9j">
            <strong className="text-brand-goldBright" data-id="element-282" data-mp="2ce2w721rdw2j">{spotsTaken}%</strong> de cupos tomados
          </span>
          <a href="#pricing" className="rounded-full bg-brand-goldBright px-3 py-1 text-xs font-bold text-brand-purpleDark transition-colors hover:bg-brand-goldLight" data-id="element-283" data-mp="150r609l9xkmd">
            VER PACK →
          </a>
        </div>
        <div className="relative overflow-hidden md:hidden" data-id="element-284" data-mp="12dqg25y001aa">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-285" data-mp="17duxby6qd01k">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-286" data-mp="jp1xhqmzm81o">
                <span data-id="element-287" data-mp="jo0n7odsppl0">
                  ⏰ Cierra en <strong data-id="element-288" data-mp="ofs4t9ez4kz0">{time}</strong>
                </span>
                <span data-id="element-289" data-mp="ohd1b4kumdzi">•</span>
                <span data-id="element-290" data-mp="9r5mqzxypf43">
                  <strong className="text-brand-goldBright" data-id="element-291" data-mp="9rxbbqt56ckv">{spotsTaken}%</strong> de cupos tomados
                </span>
                <a href="#pricing" className="rounded-full bg-brand-goldBright px-2.5 py-1 text-brand-purpleDark" data-id="element-292" data-mp="er0h5dgy4mtw">
                  VER PACK →
                </a>
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}